import { ScrollBarPanel } from './ScrollBarPanel';

export default ScrollBarPanel;
